
import { useNavigate } from "react-router";
import {ROUTES} from '../../config/routes'
import ContactUsButton from "../../components/ButtonContactUs/ButtonContactUs";
import { Button } from "cdhs-ui-library";
import { BsArrowRightShort } from "react-icons/bs";
import { useTranslations } from "../../contexts/LanguageContext";
import Overlay from "../../components/Overlay/Overlay";
import IMAGE from "../../config/imgConfig";
function ErrorPage() {
  const navigate = useNavigate();
  const t = useTranslations()

  return (
    <Overlay>
    <img src={IMAGE.ERROR_PAGE.url} alt={IMAGE.ERROR_PAGE.alt} />
      <h1>{t("errorPage_title","The page you requested couldn't be found")}</h1>
      <p>{t("errorPage_content","We're sorry about that! Let's get you back on track.")}</p>
    <Button caption="Go to home page" fullWidth variant="NYTD" iconPosition="Right" image={<BsArrowRightShort/>} onClick={()=>navigate(ROUTES.HOME)} />
    <ContactUsButton onClick={()=>navigate(ROUTES.CONTACT)}/>
    </Overlay>
  );
}

export default ErrorPage;
